import Cookie from 'js-cookie';
import { G2S } from '../g2s';

class LogglyTrackerClass {
    private LOGGLY_INPUT_PREFIX = 'http' + (('https:' === document.location.protocol ? 's' : '')) + '://';
    private LOGGLY_COLLECTOR_DOMAIN = 'logs-01.loggly.com';
    private LOGGLY_SESSION_KEY = 'logglytrackingsession';
    private LOGGLY_PROXY_DOMAIN = 'loggly';

    private key = false;
    private sendConsoleErrors = false;
    private tag = 'jslogger';
    private useDomainProxy = false;
    private useUtfEncoding = false;
    sessionId: any;
    inputUrl: string;
    logglyCollectorDomain: any;

    get uuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    private setTag(tracker: any, tag: any) {
        tracker.tag = tag;
    }
    private setUtfEncoding(tracker: any, useUtfEncoding: any){
        tracker.useUtfEncoding = useUtfEncoding;
    }
    private setSendConsoleError(tracker: any, sendConsoleErrors: any) {
        tracker.sendConsoleErrors = sendConsoleErrors;

        if (tracker.sendConsoleErrors === true) {
            const _onerror = window.onerror;
            //send console error messages to Loggly
            window.onerror = function (msg, url, line, col, err){
                tracker.push({ 
                    category: 'BrowserJsException',
                    exception: {
                        message: msg,
                        url: url,
                        lineno: line,
                        colno: col,
                        stack: err ? err.stack : 'n/a'
                    }
                });

                if (_onerror && typeof _onerror === 'function') {
                    // eslint-disable-next-line prefer-rest-params
                    _onerror.apply(window, arguments);
                }
            };
        }
    }
    private setInputUrl() {
        if (this.useDomainProxy == true) {
            this.inputUrl = this.LOGGLY_INPUT_PREFIX
                + window.location.host
                + '/'
                + this.LOGGLY_PROXY_DOMAIN
                + '/inputs/'
                + this.key
                + '/tag/'
                + this.tag;
        }
        else {
            this.inputUrl = this.LOGGLY_INPUT_PREFIX
                + (this.logglyCollectorDomain || this.LOGGLY_COLLECTOR_DOMAIN)
                + '/inputs/'
                + this.key
                + '/tag/'
                + this.tag;
        }
    }
    public setSession(sessionId?: any) {
        if (sessionId) {
            this.sessionId = sessionId;
            this.setCookie(this.sessionId);
        } else if (!this.sessionId) {
            this.sessionId = this.readCookie();
            if (!this.sessionId) {
                this.sessionId = this.uuid;
                this.setCookie(this.sessionId);
            }
        }
    }
    private setKey(key: any) {
        this.key = key;
        this.setSession();
        this.setInputUrl();
    }
    private setDomainProxy(useDomainProxy: any) {
        this.useDomainProxy = useDomainProxy;
        //refresh inputUrl value
        this.setInputUrl();
    }
    public push(data: any) {
        const type = typeof data;

        if (!data || !(type === 'object' || type === 'string')) {
            return;
        }

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;


        if (type === 'string') {
            data = {
                'text': data
            };
        } else {
            if (data.logglyCollectorDomain) {
                this.logglyCollectorDomain = data.logglyCollectorDomain;
                return;
            }

            if (data.sendConsoleErrors !== undefined) {
                this.setSendConsoleError(this, data.sendConsoleErrors);
            }

            if (data.tag) {
                this.setTag(this, data.tag);
            }

            if (data.useUtfEncoding !== undefined) {
                this.setUtfEncoding(this, data.useUtfEncoding);
            }

            if (data.useDomainProxy) {
                this.setDomainProxy(data.useDomainProxy);
            }

            if (data.logglyKey) {
                this.setKey(data.logglyKey);
                return;
            }

            if (data.sessionId) {
                self.setSession(data.sessionId);
                return;
            }
        }

        if (!self.key) {
            return;
        }

        self.track(data);
    }

    public track(data: any) {
        // inject session id
        data.sessionId = this.sessionId;

        try {
            //creating an asynchronous XMLHttpRequest
            const xmlHttp = new XMLHttpRequest();
            xmlHttp.open('POST', this.inputUrl, true); //true for asynchronous request
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (this.useUtfEncoding === true) {
                xmlHttp.setRequestHeader('Content-Type', 'text/plain; charset=utf-8');
            } else {
                xmlHttp.setRequestHeader('Content-Type', 'text/plain');
            }
            xmlHttp.send(JSON.stringify(data));

        } catch (ex) {
            if (window && window.console && typeof window.console.log === 'function') {
                console.log('Failed to log to loggly because of this exception:\n' + ex);
                console.log('Failed log data:', data);
            }
        }
    }
    public readCookie() {
        return Cookie.get('logglytrackingsession');
    }
    public setCookie(value: string) {
        Cookie.set(
            this.LOGGLY_SESSION_KEY,
            value,
            {
                path: '/',
                domain: G2S.config.cookieDomain,
                sameSite: G2S.isSecure ? 'none' : undefined, 
                secure: G2S.isSecure
            });
    }
}

export const _LTracker = new LogglyTrackerClass();